/** Format and edit times as a 12-hour clock while storing HH:mm for the API. */

export function formatTime12h(t: string): string {
  if (!t) return '';
  const [hs, ms] = t.split(':');
  const h = Number(hs);
  const m = Number(ms ?? 0);
  if (Number.isNaN(h)) return t;
  const ampm = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 || 12;
  return m ? `${h12}:${String(m).padStart(2, '0')} ${ampm}` : `${h12} ${ampm}`;
}

export function parseTimeParts(t: string): { hour12: number; minute: number; ampm: 'AM' | 'PM' } {
  const [hs, ms] = (t || '09:00').split(':');
  let h = Number(hs);
  let m = Number(ms ?? 0);
  if (Number.isNaN(h)) h = 9;
  if (Number.isNaN(m)) m = 0;
  const ampm: 'AM' | 'PM' = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return { hour12, minute: m, ampm };
}

export function toHHmm(hour12: number, minute: number, ampm: 'AM' | 'PM'): string {
  let h = hour12 % 12;
  if (ampm === 'PM') h += 12;
  return `${String(h).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}
